import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { formatMonthForDisplay } from "../../../../utils/dateUtils";

const GottonVendorsTable = ({ paginatedCustomers }) => (
  <TableContainer component={Paper}>
    <Table sx={{ minWidth: 650 }} aria-label="customers table">
      <TableHead>
        <TableRow>
          <TableCell sx={{ fontWeight: "bold", minWidth: 100, maxWidth: 150 }}>
            Month
          </TableCell>
          <TableCell sx={{ fontWeight: "bold", minWidth: 150, maxWidth: 200 }}>
            Full Name
          </TableCell>
          <TableCell sx={{ fontWeight: "bold", minWidth: 120, maxWidth: 150 }}>
            Total Customers
          </TableCell>
          <TableCell sx={{ fontWeight: "bold", minWidth: 120, maxWidth: 150 }}>
            Total Offers
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {paginatedCustomers.map((customer, index) => (
          <TableRow key={index}>
            <TableCell sx={{ minWidth: 100, maxWidth: 150 }}>
              {formatMonthForDisplay(customer.MONTH)}
            </TableCell>
            <TableCell sx={{ minWidth: 150, maxWidth: 200 }}>
              {customer.first_name} {customer.last_name}
            </TableCell>
            <TableCell sx={{ minWidth: 120, maxWidth: 150 }}>
              {customer.totalCustomers}
            </TableCell>
            <TableCell sx={{ minWidth: 120, maxWidth: 150 }}>
              {customer.totalMessages}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default GottonVendorsTable;
